__turbopack_context__.v({
  "container": "ProductImage-module__WpBSBW__container",
});
